/* eslint-disable complexity */
/* eslint-disable no-case-declarations */
/* eslint-disable default-case */
/* eslint-disable no-nested-ternary */
import React from 'react';
import classNames from 'classnames';
import TestUserInfo from './TestUserInfo';
import Subtest from './Subtest';
import SubtestReport from './SubtestReport';
import SubtestAnswers from './SubtestAnswers';
import strings from 'utils/strings';
import getQuestionChoices from '../Utils/getQuestionChoices';
import moment from 'moment';
import {connect} from 'react-redux';
import '../../TestView/styles.scss';

import getSingleNormingTestResult from 'api/getSingleNormingTestResult';
import deleteSubTest from '../../../api/deleteSubtest';
import updateLogEvent from 'api/updateLogEvent';

import {withRouter} from 'react-router-dom';

import HorizontalBarChart from 'components/HorizontalBarChart';

import childWordchainAnswers from './child-wordchain-answers.json';
import childWordchainAnswersNn from './child-wordchain-answers-nn.json';
import test5Questions from './test5.json';
import test6Questions from './test6.json';
import test5youthQuestions from './test5youth.json';
import test5youthQuestionsNn from './test5youthNn.json';
import test6youthQuestions from './test6youth.json';
import test6youthQuestionsNn from './test6youthNn.json';

import test5childQuestions from './test5child.json';
import test5childQuestionsNn from './test5childNn.json';
import test6childQuestions from './test6child.json';
import test6childQuestionsNn from './test6childNn.json';
import test6childUpperQuestions from './test6childUpper.json';
import test6childUpperQuestionsNn from './test6childUpperNn.json';
import {timeSinceWCaltered} from '../../../constants';
import HandBook from './HandBook';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faPrint, faLanguage} from '@fortawesome/free-solid-svg-icons';
import Assessment from './assessment';
import ReportIntroduction from './ReportIntroduction';
import AddNotesModal from 'components/AddNotesModel';
import AlertBox from 'components/CreateNotification/alert';
class SingleTest extends React.Component {
	constructor() {
		super();
		this.state = {
			showTestUserInfo: false,
			testResult: null,
			testType: null,
			testId: null,
			testKey: null,
			showResultsTab: false,
			showReportTab: true,
			showInformationTab: false,
			showHandBookTab: false,
			showResultsActive: 'tablink1',
			showReportActive: 'tablink2-active',
			showInformationActive: 'tablink3',
			showHandBookActive: 'tablink4',
			showAddNotesModal: false,
			reportNotes: '',
			showAlert: false,
			birthDate: null,
			testReportLang: 'no',
			isLoading: true, // NEW
			emptyReason: null, // optional, if you want to differentiate cases
			buttonTabs: [
				{
					id: 2,
					value: 'report',
					buttonClass: 'tablink2-active',
					text: 'Rapport',
				},
				{
					id: 'defaultOpen',
					value: 'result',
					buttonClass: 'tablink1',
					text: strings.results,
				},
				{
					id: 3,
					value: 'info',
					buttonClass: 'tablink3',
					text: strings.userinformation,
				},
				{
					id: 4,
					value: 'book',
					buttonClass: 'tablink4',
					text: strings.handbook,
				},
			],
		};
	}

	componentDidMount() {
		this._isMounted = true;
		this.getTestResultAndMetadata();
	}
	componentWillUnmount() {
		this._isMounted = false;
	}

	formatTest7Answers(subtest, questions) {
		const items = subtest && subtest.answers ? subtest.answers : [];
		const acList =
			subtest && subtest.answersCorrect ? subtest.answersCorrect : [];
		var out = [];

		function findCorrectLettersById(id) {
			for (var k = 0; k < acList.length; k++) {
				var row = acList[k] || {};
				var rid =
					typeof row.id === 'string' ? parseInt(row.id, 10) : row.id;
				if (rid === id) {
					var v = row.value;
					if (Array.isArray(v)) return v;
					if (v && Array.isArray(v.answerArray)) return v.answerArray;
					if (typeof v === 'string') return [v];
				}
			}
			return [];
		}

		for (var i = 0; i < items.length; i++) {
			var a = items[i] || {};
			var val = a.value || {};
			var id = typeof a.id === 'string' ? parseInt(a.id, 10) : a.id;

			var q = null;
			if (questions) {
				if (questions[id - 1]) q = questions[id - 1];
				else if (questions[id]) q = questions[id];
			}

			var choiceMap = q ? getQuestionChoices(q) : null;

			var selectedLetters =
				val && val.answerArray && val.answerArray.map
					? val.answerArray
					: [];
			var selectedLabels = [];
			for (var s = 0; s < selectedLetters.length; s++) {
				var letter = selectedLetters[s];
				if (
					choiceMap &&
					choiceMap[letter] &&
					choiceMap[letter].choice
				) {
					selectedLabels.push(choiceMap[letter].choice);
				} else {
					selectedLabels.push(letter);
				}
			}

			var correctLetters = findCorrectLettersById(id);
			var correctLabels = [];
			for (var c = 0; c < correctLetters.length; c++) {
				var clet = correctLetters[c];
				if (choiceMap && choiceMap[clet] && choiceMap[clet].choice) {
					correctLabels.push(choiceMap[clet].choice);
				} else {
					correctLabels.push(clet);
				}
			}

			out.push({
				id: id,

				value: selectedLabels.join(', '),
				isCorrect: !!val.isCorrect,
				isAnswered: !!val.isAnswered,
				correctValues: correctLabels,
				question:
					q && q.question
						? q.question
						: q && q.prompt
							? q.prompt
							: q && q.word
								? q.word
								: '',
				choices: choiceMap,
				// new, for chip view
				selectedLabels: selectedLabels,
			});
		}

		return out;
	}

	async getTestResultAndMetadata() {
		const id =
			this.props && this.props.match && this.props.match.params
				? this.props.match.params.id
				: null;

		if (!id) return;

		window.scrollTo(0, 0);
		if (this._isMounted)
			this.setState({isLoading: true, emptyReason: null});
		try {
			const testResult = await getSingleNormingTestResult(id);
			if (!this._isMounted) return;
			const testType =
				testResult && testResult.type ? testResult.type : '';
			const testUser =
				testResult && testResult.testUser ? testResult.testUser : {};
			const birthDate =
				testUser && testUser.birthDate
					? ' ' +
						strings.born +
						moment(testUser.birthDate).format('DD.MM.YYYY')
					: '';
			const hasSubtests =
				Array.isArray(testResult?.subtests) &&
				testResult.subtests.length > 0;

			if (!testResult || !hasSubtests) {
				this.setState({
					testResult: testResult || null,
					isLoading: false,
					emptyReason: !testResult ? 'not-found' : 'no-subtests',
					testType,
					testUser,
					birthDate,
				});
				return;
			}

			var childGrade = null;
			if (testType === 'child-screening') {
				const processed = this.reOrderChildScreening(testResult);
				if (
					processed &&
					processed.testUser &&
					processed.testUser.education &&
					typeof processed.testUser.education.youthGrade !==
						'undefined'
				) {
					childGrade = processed.testUser.education.youthGrade;
				}
			}

			const pickQuestions = function (subtest) {
				if (!subtest) return false;

				switch (testType) {
					case 'adult-screening':
						if (subtest.id === 5) return test5Questions;
						if (subtest.id === 6) return test6Questions;
						return false;

					case 'youth-screening':
						if (subtest.id === 5) {
							if (subtest.language === 'no')
								return test5youthQuestions['8'];
							if (subtest.language === 'nn')
								return test5youthQuestionsNn['8'];
						}
						if (subtest.id === 6) {
							if (subtest.language === 'no')
								return test6youthQuestions;
							if (subtest.language === 'nn')
								return test6youthQuestionsNn;
						}
						return false;

					case 'child-screening':
						if (subtest.id === 5) {
							var gradeStr =
								childGrade !== null && childGrade !== undefined
									? String(childGrade)
									: '';
							if (subtest.language === 'no')
								return test5childQuestions[gradeStr];
							if (subtest.language === 'nn')
								return test5childQuestionsNn[gradeStr];
						}
						if (subtest.id === 6) {
							if (subtest.language === 'no') {
								return childGrade < 5
									? test6childQuestions
									: test6childUpperQuestions;
							}
							if (subtest.language === 'nn') {
								return childGrade < 5
									? test6childQuestionsNn
									: test6childUpperQuestionsNn;
							}
						}
						return false;

					default:
						return false;
				}
			}.bind(this);

			if (
				testResult &&
				testResult.subtests &&
				testResult.subtests.forEach
			) {
				testResult.subtests.forEach((subtest) => {
					var questions = pickQuestions(subtest);
					if (subtest.id === 4) {
						subtest.formattedAnswers =
							this.formatTypingSpeedAnswers(subtest.answers);
						return;
					}

					if (subtest.id === 7) {
						subtest.formattedAnswers = this.formatTest7Answers(
							subtest,
							questions
						);
						return;
					}
					if (subtest.id === 5 && testType !== 'child-screening') {
						const correctAnswers =
							subtest.answersCorrect &&
							subtest.answersCorrect.norming
								? subtest.answersCorrect.norming
								: subtest.answersCorrect &&
									  subtest.answersCorrect.production
									? subtest.answersCorrect.production
									: subtest.answersCorrect;

						subtest.formattedAnswers =
							this.getAnswersWithCorrectAnswer(
								subtest.answers,
								correctAnswers,
								questions,
								true
							);

						return;
					}

					if (subtest.id === 1 && testType === 'child-screening') {
						var currentChildGrade =
							testUser &&
							testUser.education &&
							typeof testUser.education.youthGrade !== 'undefined'
								? testUser.education.youthGrade
								: childGrade;

						subtest.formattedAnswers =
							this.getAnswersWithCorrectAnswerforWD(
								subtest.answers || [],
								subtest.answersCorrect?.norming || [],
								questions,
								currentChildGrade
							);

						return;
					}
					if (subtest.id === 1 && testType === 'youth-screening') {
						const correctAnswers = this.getNormingCorrectAnswers(
							subtest.answersCorrect
						);

						subtest.formattedAnswers =
							this.getAnswersWithCorrectAnswer(
								subtest.answers || [],
								correctAnswers
							);

						return;
					}

					if (subtest.id === 1 && testType === 'adult-screening') {
						// Word Dictation – youth
						subtest.formattedAnswers =
							this.getAnswersWithCorrectAnswer(
								subtest.answers,
								subtest.answersCorrect &&
									subtest.answersCorrect.norming
									? subtest.answersCorrect.norming
									: undefined,
								questions
							);
						return;
					}

					if (subtest.id === 2 && testType === 'child-screening') {
						subtest.formattedAnswers =
							this.getAnswersWithCorrectAnswerforWC(
								subtest.answers || [],
								subtest.answersCorrect
							);

						return;
					}
					if (subtest.id === 2 && testType === 'adult-screening') {
						const correctAnswers = this.getNormingCorrectAnswers(
							subtest.answersCorrect
						);

						subtest.formattedAnswers =
							this.getAnswersWithCorrectAnswer(
								subtest.answers || [],
								correctAnswers,
								questions
							);

						return;
					}
					if (
						subtest.id === 2 &&
						['youth-screening'].includes(testType)
					) {
						const correctAnswers =
							subtest.answersCorrect &&
							subtest.answersCorrect.norming
								? subtest.answersCorrect.norming
								: subtest.answersCorrect &&
									  subtest.answersCorrect.production
									? subtest.answersCorrect.production
									: subtest.answersCorrect;

						const reportCorrectAnswers =
							testType === 'adult-screening'
								? correctAnswers.filter(
										(answer) =>
											answer.id !== 1 && answer.id < 33
									)
								: correctAnswers;

						subtest.formattedAnswers =
							this.getAnswersWithCorrectAnswer(
								subtest.answers,
								reportCorrectAnswers,
								questions
							);

						return;
					}

					if (subtest.id === 5 && testType === 'child-screening') {
						const numericGrade = Number(childGrade);

						const correctAnswers = Array.isArray(
							subtest.answersCorrect
						)
							? subtest.answersCorrect
							: subtest.answersCorrect?.normingByGrade?.[
									numericGrade
								] ||
								subtest.answersCorrect?.norming ||
								subtest.answersCorrect?.production ||
								[];

						subtest.formattedAnswers =
							this.getAnswersWithCorrectAnswer(
								subtest.answers || [],
								correctAnswers,
								questions || [],
								true
							);

						return;
					}
					if (subtest.id === 6 && testType === 'child-screening') {
						const correctAnswers = this.getNormingCorrectAnswers(
							subtest.answersCorrect
						);

						subtest.formattedAnswers =
							this.getAnswersWithCorrectAnswer(
								subtest.answers || [],
								correctAnswers,
								questions
							);

						return;
					}
					if (subtest.id === 6 && testType !== 'child-screening') {
						const correctAnswers =
							subtest.answersCorrect &&
							subtest.answersCorrect.norming
								? subtest.answersCorrect.norming
								: subtest.answersCorrect &&
									  subtest.answersCorrect.production
									? subtest.answersCorrect.production
									: subtest.answersCorrect;

						subtest.formattedAnswers =
							this.getAnswersWithCorrectAnswer(
								subtest.answers,
								correctAnswers,
								questions
							);

						return;
					}
					if (subtest.id === 3) {
						// Word Chain – child
						subtest.formattedAnswers =
							this.getAnswersWithCorrectAnswer(
								subtest.answers,
								subtest.answersCorrect.norming,
								questions
							);
					}

					// Default path
					else {
						subtest.formattedAnswers =
							this.getAnswersWithCorrectAnswer(
								subtest.answers,
								subtest.answersCorrect,
								questions
							);
					}
				});
			}

			this.setState({
				testResult: testResult,
				testId: testResult && testResult.id ? testResult.id : null,
				testKey: testResult && testResult.key ? testResult.key : null,
				testType: testType,
				testUser: testUser,
				birthDate: birthDate,
				isLoading: false, // DONE loading with real data
				emptyReason: null,
			});
		} catch (error) {
			console.error('Failed to load test result:', error);
			if (!this._isMounted) return;
			this.setState({
				isLoading: false,
				testResult: null,
				emptyReason: 'error',
			});
		}
	}

	reOrderChildScreening(testResult) {
		let allSubtests = [];

		for (let i = 0; i < testResult.subtests.length; i++) {
			switch (testResult.subtests[i].id) {
				case 3:
					allSubtests[0] = testResult.subtests[i];
					break;
				case 7:
					allSubtests[1] = testResult.subtests[i];
					break;
				case 2:
					allSubtests[2] = testResult.subtests[i];
					break;
				case 4:
					allSubtests[3] = testResult.subtests[i];
					break;
				case 6:
					allSubtests[4] = testResult.subtests[i];
					break;
				case 5:
					allSubtests[5] = testResult.subtests[i];
					break;
				case 1:
					allSubtests[6] = testResult.subtests[i];
					break;
			}
		}
		if (allSubtests.length) {
			allSubtests = allSubtests.filter(function (element) {
				return element !== undefined;
			});

			testResult.subtests = allSubtests;
		}
		return testResult;
	}

	updatePrintLog(action) {
		updateLogEvent('print', this.state.testId, '', action);
	}

	safelyDeleteSubtest(testId, subtestId) {
		deleteSubTest(testId, subtestId).then(() => {
			const {
				testResult: {subtests},
			} = this.state;
			if (subtests.length === 1) {
				window.location.href = '/my-tests';
			} else {
				this.getTestResultAndMetadata();
			}
		});
	}

	formatTypingSpeedAnswers(answers) {
		const output = [];
		for (let i = 0; i < answers.length; i++) {
			const answerArray = answers[i].split(' ');
			output.push(
				answerArray.map((answer, index) => {
					return {
						id: index,
						value: answer,
					};
				})
			);
		}
		return output;
	}
	getNormingCorrectAnswers(answersCorrect) {
		if (Array.isArray(answersCorrect)) {
			return answersCorrect;
		}

		if (answersCorrect && Array.isArray(answersCorrect.norming)) {
			return answersCorrect.norming;
		}

		if (answersCorrect && Array.isArray(answersCorrect.production)) {
			return answersCorrect.production;
		}

		return [];
	}

	// For subtest id = 7: answers are already evaluated by backend
	formatPreEvaluatedAnswers(answers, questions) {
		const output = [];
		if (!answers || !answers.length) return output;

		for (let i = 0; i < answers.length; i++) {
			const a = answers[i] || {};
			const id = typeof a.id !== 'undefined' ? a.id : i + 1;
			const valueObj = a.value || {};
			const selected = Array.isArray(valueObj.answerArray)
				? valueObj.answerArray
				: typeof valueObj.answerArray === 'string'
					? [valueObj.answerArray]
					: [];

			const valueStr = selected.join(', ').toLowerCase();

			const answer = {
				id: id,
				value: valueStr, // "a, b, c"
				isCorrect: !!valueObj.isCorrect,
				selectedValues: selected,
				// Note: We do not set correctValues here; backend did the evaluation already.
			};

			if (questions) {
				var idx = parseInt(id, 10) - 1;
				if (isNaN(idx)) idx = (typeof id === 'number' ? id : i + 1) - 1;

				answer.question =
					questions[idx] && questions[idx].question
						? questions[idx].question
						: '';

				answer.choices = getQuestionChoices(
					questions[idx] ? questions[idx] : ''
				);
			}

			output.push(answer);
		}

		return output;
	}
	getQuestionChoicesByIdentity(question) {
		const choices = {};

		if (!question || !Array.isArray(question.choices)) {
			return choices;
		}

		question.choices.forEach((choice) => {
			const key =
				typeof choice.identity !== 'undefined'
					? choice.identity
					: choice.letter;

			choices[key] = choice;
		});

		return choices;
	}

	getAnswersWithCorrectAnswer(
		answers = [],
		answersCorrect = [],
		questions,
		useIdentityChoices = false
	) {
		const answerCorrectBackEndNorming =
			answersCorrect?.norming || answersCorrect || [];

		const output = [];
		for (let i = 0; i < answers.length; i++) {
			if (answers[i].id !== null) {
				let jInit = 0;
				let correctAnswerAltValues = null;
				//Saves us some looping if arrays are arranged as expected
				if (
					answers[i] &&
					answerCorrectBackEndNorming[i] &&
					answers[i].id === answerCorrectBackEndNorming[i].id
				) {
					jInit = i;
				}
				if (typeof answers[i].id === 'undefined') {
					break;
				}
				const currentAnswer = answers[i];
				const currentAnswerValue = currentAnswer.value
					.toLowerCase()
					.trim();
				for (
					let j = jInit;
					j < answerCorrectBackEndNorming.length;
					j++
				) {
					const currentCorrectAnswer = answerCorrectBackEndNorming[j];
					if (
						currentAnswer.id === currentCorrectAnswer.id &&
						currentCorrectAnswer.value !== null
					) {
						const correctAnswerValue = currentCorrectAnswer.value
							.toLowerCase()
							.trim();

						if (
							answerCorrectBackEndNorming[j] &&
							answerCorrectBackEndNorming[j].hasOwnProperty(
								'altValues'
							)
						) {
							correctAnswerAltValues =
								answerCorrectBackEndNorming[i].altValues;
						}
						const isCorrectAnswer =
							currentAnswerValue === currentCorrectAnswer.value ||
							currentAnswerValue === correctAnswerAltValues;

						const hasAltValues =
							Array.isArray(currentCorrectAnswer.altValues) ||
							correctAnswerAltValues;
						const isCorrectAltValue =
							hasAltValues &&
							currentCorrectAnswer.altValues.indexOf(
								currentAnswerValue
							) !== -1;

						const answer = {
							id: currentAnswer.id,
							value: currentAnswerValue,
							isCorrect: isCorrectAnswer || isCorrectAltValue,
							correctValues: [correctAnswerValue],
						};

						if (hasAltValues) {
							answer.correctValues = [correctAnswerValue].concat(
								currentCorrectAnswer.altValues
							);
						}

						if (questions) {
							const question =
								questions[currentAnswer.id - 1] || null;

							answer.question =
								question && question.question
									? question.question
									: '';

							answer.choices =
								question && Array.isArray(question.choices)
									? useIdentityChoices
										? this.getQuestionChoicesByIdentity(
												question
											)
										: getQuestionChoices(question)
									: {};
						}

						output.push(answer);
						break;
					}
				}
			}
		}
		return output;
	}

	getAnswersWithCorrectAnswerforWD(
		answers = [],
		answersCorrect = [],
		questions,
		childGrade
	) {
		const output = [];

		const normalize = (value) => {
			if (value === null || typeof value === 'undefined') {
				return '';
			}

			const punctuation = /[\.,?!]/g;

			return String(value).toLowerCase().trim().replace(punctuation, '');
		};

		const correctAnswersForGrade = (answersCorrect || [])
			.map((answer) => {
				const correctValue =
					Number(childGrade) < 5
						? answer.value
						: answer.upperGradeValue;

				return {
					...answer,
					correctValue,
				};
			})
			.filter(
				(answer) =>
					answer.correctValue !== null &&
					typeof answer.correctValue !== 'undefined'
			);

		const correctAnswersById = new Map(
			correctAnswersForGrade.map((answer) => [String(answer.id), answer])
		);

		const questionsById = new Map(
			(questions || [])
				.filter(
					(question) =>
						question &&
						question.id !== null &&
						typeof question.id !== 'undefined'
				)
				.map((question) => [String(question.id), question])
		);

		for (let i = 0; i < answers.length; i++) {
			const currentAnswer = answers[i];

			if (
				!currentAnswer ||
				currentAnswer.id === null ||
				typeof currentAnswer.id === 'undefined'
			) {
				continue;
			}

			const currentCorrectAnswer = correctAnswersById.get(
				String(currentAnswer.id)
			);

			if (!currentCorrectAnswer) {
				continue;
			}

			const currentAnswerValue = normalize(currentAnswer.value);
			const correctAnswerValue = normalize(
				currentCorrectAnswer.correctValue
			);

			const altValues = Array.isArray(currentCorrectAnswer.altValues)
				? currentCorrectAnswer.altValues
						.filter(
							(value) =>
								value !== null && typeof value !== 'undefined'
						)
						.map(normalize)
				: [];

			const answer = {
				id: currentAnswer.id,
				value: currentAnswerValue,
				isCorrect:
					currentAnswerValue === correctAnswerValue ||
					altValues.includes(currentAnswerValue),
				correctValues: [correctAnswerValue, ...altValues],
			};

			if (questions) {
				const question =
					questionsById.get(String(currentAnswer.id)) ||
					questions[currentAnswer.id - 1];

				answer.question = question ? question.question : '';

				answer.choices = getQuestionChoices(question || '');
			}

			output.push(answer);
		}

		return output;
	}

	getAnswersWithCorrectAnswerforWC(answers = [], answerCorrectBackEnd = {}) {
		const correctAnswers = Array.isArray(answerCorrectBackEnd)
			? answerCorrectBackEnd
			: answerCorrectBackEnd?.norming || [];

		const correctAnswersById = new Map(
			correctAnswers
				.filter(
					(answer) =>
						answer &&
						answer.id !== null &&
						typeof answer.id !== 'undefined'
				)
				.map((answer) => [String(answer.id), answer])
		);

		const output = [];

		for (let i = 0; i < answers.length; i++) {
			const currentAnswer = answers[i];

			if (
				!currentAnswer ||
				currentAnswer.id === null ||
				typeof currentAnswer.id === 'undefined'
			) {
				continue;
			}

			const currentCorrectAnswer = correctAnswersById.get(
				String(currentAnswer.id)
			);

			if (
				!currentCorrectAnswer ||
				typeof currentCorrectAnswer.value !== 'string'
			) {
				continue;
			}

			const currentAnswerValue =
				typeof currentAnswer.value === 'string'
					? currentAnswer.value.trim()
					: '';

			const correctAnswerValue = currentCorrectAnswer.value.trim();

			const altValues = Array.isArray(currentCorrectAnswer.altValues)
				? currentCorrectAnswer.altValues
						.filter((value) => typeof value === 'string')
						.map((value) => value.trim())
				: [];

			const normalizedCurrent = currentAnswerValue
				.toLowerCase()
				.replace(/\s+/g, ' ');

			const normalizedCorrect = correctAnswerValue
				.toLowerCase()
				.replace(/\s+/g, ' ');

			const normalizedAltValues = altValues.map((value) =>
				value.toLowerCase().replace(/\s+/g, ' ')
			);

			output.push({
				id: currentAnswer.id,
				value: currentAnswerValue,
				isCorrect:
					normalizedCurrent === normalizedCorrect ||
					normalizedAltValues.includes(normalizedCurrent),
				correctValues: [correctAnswerValue, ...altValues],
			});
		}

		return output;
	}

	returnTestUserGrade(notAvailable) {
		let testUserGrade = null;
		const {testUser} = this.state;

		if (
			['child-screening', 'youth-screening'].includes(this.state.testType)
		) {
			testUserGrade = (
				<>
					<br />
					{`${testUser.education.youthGrade}.${strings.grade}`}
					<br />
				</>
			);
		} else if (
			testUser?.education?.hasOwnProperty('highestCompletedEducation')
		) {
			const highestCompletedEducation = testUser.education
				.highestCompletedEducation
				? testUser.education.highestCompletedEducation
				: notAvailable;

			testUserGrade = (
				<>
					<br />
					{`${strings.education}: ${highestCompletedEducation}`}
					<br />
				</>
			);
		}
		return testUserGrade;
	}

	setRelevantTab(key, index) {
		const {buttonTabs} = this.state;
		for (let i = 0; i < buttonTabs.length; i++) {
			if (
				i === index &&
				!buttonTabs[index].buttonClass.includes('active')
			) {
				const counter = index + 1;
				buttonTabs[index].buttonClass = `tablink${counter}-active`;
			} else {
				const counter = i + 1;
				buttonTabs[i].buttonClass = `tablink${counter}`;
			}
		}
		switch (key) {
			case 'result':
				this.setState({
					showResultsTab: true,
					showReportTab: false,
					showInformationTab: false,
					showTestUserInfo: false,
					showHandBookTab: false,

					buttonTabs,
				});
				break;
			case 'report':
				this.setState({
					showResultsTab: false,
					showReportTab: true,
					showInformationTab: true,
					showTestUserInfo: false,
					showHandBookTab: false,

					showHandBookActive: 'tablink4',
					buttonTabs,
				});
				break;
			case 'info':
				this.setState({
					showResultsTab: false,
					showReportTab: true,
					showInformationTab: false,
					showTestUserInfo: true,
					showHandBookTab: false,

					buttonTabs,
				});
				break;
			case 'book':
				this.setState({
					showResultsTab: false,
					showReportTab: false,
					showInformationTab: false,
					showHandBookTab: true,
					showTestUserInfo: false,
					buttonTabs,
				});
				break;
		}
	}
	toggleAddNotesModal = () => {
		this.setState({showAddNotesModal: !this.state.showAddNotesModal});
	};
	onClickTranslateReport = () => {
		const {testReportLang} = this.state;
		const {
			testResult: {
				subtests: [{language}],
			},
		} = this.state;
		let translateTo = 'nn';
		if (testReportLang === 'nn') {
			translateTo = 'no';
		}

		this.setState({testReportLang: translateTo});
	};
	render() {
		const {
			showTestUserInfo,
			testResult,
			birthDate,
			reportNotes,
			testReportLang,
			isLoading,
			emptyReason,
		} = this.state;

		if (isLoading) {
			return (
				<section
					className="empty-state empty-state--loading"
					aria-busy="true"
					aria-live="polite"
				>
					<div className="skeleton skeleton--icon" />
					<div className="skeleton skeleton--title" />
					<div className="skeleton skeleton--line" />
					<div className="skeleton skeleton--line short" />
				</section>
			);
		}

		if (!testResult) {
			return (
				<section
					className="empty-state"
					role="status"
					aria-live="polite"
				>
					<div className="empty-state__icon" aria-hidden="true">
						<svg width="24" height="24" viewBox="0 0 24 24">
							<path
								d="M6 4h9a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z"
								fill="none"
								stroke="currentColor"
								strokeWidth="1.5"
							/>
							<path
								d="M9 3v4m0-4h4a2 2 0 0 1 2 2v2H7V5a2 2 0 0 1 2-2zM8 12h8M8 16h6"
								fill="none"
								stroke="currentColor"
								strokeWidth="1.5"
							/>
						</svg>
					</div>

					<h1 className="empty-state__title">
						{strings.noTestResultsTitle}
					</h1>
					<p className="empty-state__body">
						{emptyReason === 'error'
							? strings.noTestResultsErrorBody
							: strings.noTestResultsBody}
					</p>
					<div className="empty-state__actions">
						<button
							type="button"
							className="btn btn--primary"
							onClick={() => window.location.reload()}
						>
							{strings.reloadButton}
						</button>
					</div>
					<p className="empty-state__hint">
						{strings.noTestResultsHint}
					</p>
				</section>
			);
		}

		const {testUser} = testResult;

		const {
			currentUser: {
				firstName: adminFirstName = '',
				lastName: adminLastName = '',
			} = {},
		} = this.props;
		const hasSubtests =
			Array.isArray(testResult.subtests) &&
			testResult.subtests.length > 0;
		const language = hasSubtests
			? testResult.subtests[0].language
			: undefined;
		const notAvailable =
			testReportLang === 'nn'
				? strings._props.nn.notavailable
				: strings.notavailable;
		const adminCompleteName = `${adminFirstName} ${adminLastName}`;
		const ownerFullName = testResult.adminFullName
			? testResult.adminFullName
			: language === 'nn'
				? '<Ikkje tilgjengeleg>'
				: '<Ikke tilgjengelig>';
		const isCommon = adminCompleteName === ownerFullName;
		const completeName = testUser.firstName
			? `${testUser.firstName} ${testUser.lastName}`
			: strings.hiddenname;
		const firstName = testUser?.firstName || '<Skjult navn>';
		const languageStatus =
			testUser.isForeign == 1
				? 'Norsk som andrespråk'
				: testUser.isForeign == 0
					? 'Norsk som førstespråk'
					: notAvailable;

		const infoReportBelowPresentsInformation =
			testReportLang === 'nn'
				? strings._props.nn.info_report_belowpresentsinformation
				: strings.info_report_belowpresentsinformation;
		const infoTestWasCompletedOn =
			testReportLang === 'nn'
				? strings._props.nn.info_testwascompletedon
				: strings.info_testwascompletedon;
		const inforScrAgeAtCommencement =
			testReportLang === 'nn'
				? strings._props.nn.infor_scr_ageAtCommencement
				: strings.infor_scr_ageAtCommencement;
		const zscorered =
			testReportLang === 'nn'
				? strings._props.nn.zscorered
				: strings.zscorered;
		const zscoregreen =
			testReportLang === 'nn'
				? strings._props.nn.zscoregreen
				: strings.zscoregreen;
		const zscoreblue =
			testReportLang === 'nn'
				? strings._props.nn.zscoreblue
				: strings.zscoreblue;
		return (
			<div className="lit-single-test">
				<div>
					<div
						className={
							this.state.testType === 'youth-screening'
								? 'lit-single-youthtest-title-desc'
								: 'lit-single-adulttest-title-desc'
						}
					>
						<h1 className="lit-page-title">
							{this.state.showHandBookTab
								? strings.formatString(
										strings.handbooktitle,
										<>
											<b>{strings.handbookUpper}</b>
											<br />
											<br />
										</>
									)
								: this.state.showResultsTab
									? strings.formatString(
											strings.dynamicheaderfortestresult_adult,
											this.state.testType ===
												'youth-screening' ? (
												<>
													<br />
													<br />
													<b>
														{strings.youthscreening}
													</b>
												</>
											) : this.state.testType ===
											  'adult-screening' ? (
												<>
													<br />
													<br />
													<b>
														{strings.adultscreening}
													</b>
												</>
											) : (
												<b>
													<br />
													<br />
													{
														strings.dysmateCChildScreening
													}
												</b>
											)
										)
									: this.state.showTestUserInfo
										? strings.formatString(
												strings.dynamicheaderfortestcandidate_adult,
												this.state.testType ===
													'youth-screening' ? (
													<>
														<br />
														<br />
														<b>
															{
																strings.youthscreening
															}
														</b>
													</>
												) : this.state.testType ===
												  'adult-screening' ? (
													<>
														<br />
														<br />
														<b>
															{
																strings.adultscreening
															}
														</b>
													</>
												) : (
													<>
														<b>
															<br />
															<br />
															{
																strings.dysmateCChildScreening
															}
														</b>
													</>
												)
											)
										: this.state.showReportTab
											? strings.formatString(
													strings.dynamicheaderfortestreport_adult,
													this.state.testType ===
														'youth-screening' ? (
														<>
															<br />
															<br />
															<b>
																{
																	strings.youthscreening
																}
															</b>
														</>
													) : this.state.testType ===
													  'adult-screening' ? (
														<>
															{' '}
															<br />
															<br />
															<b>
																{
																	strings.adultscreening
																}
															</b>
														</>
													) : (
														<>
															<br /> <br />
															<b>
																{
																	strings.dysmateCChildScreening
																}
															</b>
														</>
													)
												)
											: ''}
						</h1>
						<div>
							{!this.state.showHandBookTab &&
								this.state.showReportTab &&
								!this.state.showTestUserInfo && (
									<>
										<br />

										<span className="lit-printed-by">
											{strings.administratorLabel}
										</span>
										<b style={{marginLeft: '4px'}}>
											{ownerFullName}
										</b>
										{!isCommon && (
											<>
												<span className="lit-printed-by">
													{strings.savedByLabel}
												</span>
												<b style={{marginLeft: '4px'}}>
													{adminCompleteName}
												</b>
											</>
										)}
									</>
								)}
						</div>
						{!this.state.showHandBookTab && (
							<p className="lit-page-lead">
								{strings.formatString(
									this.state.showResultsTab
										? strings.info_results_belowpresentsinformation
										: this.state.showTestUserInfo
											? strings.info_user_belowpresentsinformation
											: this.state.showReportTab
												? infoReportBelowPresentsInformation
												: '',
									<>
										<br />
										<b>{completeName}</b>
										<br />{' '}
									</>,

									<span>{birthDate}</span>,
									<span>
										{this.returnTestUserGrade(notAvailable)}
									</span>
								)}
								{testResult.completedAt ? (
									strings.formatString(
										infoTestWasCompletedOn,
										<>
											<b>
												{moment(
													testResult.completedAt
												).format('DD.MM.YYYY')}
												.
											</b>
											<br />
										</>
									)
								) : (
									<>
										{strings.info_testwasNotcompletedon}{' '}
										<br />
									</>
								)}
								{strings.formatString(
									inforScrAgeAtCommencement,
									<b>{testUser.age.years}</b>,
									<b>{testUser.age.months}</b>
								)}
								<br />
								Språkstatus: <b>{languageStatus}</b>
							</p>
						)}
					</div>

					<div className="lit-tab-wrapper">
						<div className="lit-results-line" />
						{this.state.buttonTabs.map((tab, index) => {
							const id = tab.id;
							const value = tab.value;
							const buttonClass = tab.buttonClass;
							const btnText = tab.text;

							// eslint-disable-next-line react/jsx-key
							return (
								<button
									className={buttonClass}
									id={id}
									key={index}
									value={value}
									disabled={buttonClass.includes('active')}
									onClick={(e) => {
										this.setRelevantTab(
											e.target.value,
											index
										);
									}}
								>
									{btnText}
								</button>
							);
						})}
					</div>

					{this.state.showResultsTab &&
						!this.state.showReportTab &&
						!this.state.showInformationTab && (
							<div className="lit-histogram-Test_Details">
								<div className="lit-printBtn">
									<button
										className={classNames('print-hide', {
											'lit-btn2 see-more': true,
											'bg-tertiary': true,
										})}
										onClick={() => {
											window.print();
											this.updatePrintLog('Results');
										}}
									>
										<FontAwesomeIcon
											size="lg"
											className="lit-icon-btns"
											icon={faPrint}
										/>

										<p className="lit-btns-txt">
											{strings.formatString(
												strings.testresult
											)}
										</p>
									</button>
								</div>
								<div className="lit-results-background">
									<div className="sub-test total print-summary">
										{!testResult.completedAt && (
											<div className="incomplete-notice">
												{strings.incompleteMessage}
											</div>
										)}

						<div className="summary-section">
						<h3 className="sub-test__name big">
											{strings.formatString(
												strings.summary,
												'resultater'
											)}
										</h3>
						<div className="summary-chart">
											<HorizontalBarChart
												subtests={testResult.subtests}
												testType={this.state.testType}
											/>
						</div>
						</div>
						{/* Must be removed before deployment */}

										<div className="explanations">
											<div className="explanation">
												<div className="explanation__figure negative" />
												<p className="explanation__text">
													{strings.formatString(
														zscorered,
														<em>{strings.under}</em>
													)}
												</p>
											</div>
											<div className="explanation">
												<div className="explanation__figure neutral" />
												<p className="explanation__text">
													{zscoreblue}
												</p>
											</div>
											<div className="explanation">
												<div className="explanation__figure positive" />
												<p className="explanation__text">
													{strings.formatString(
														zscoregreen,
														<em>{strings.over}</em>
													)}
												</p>
											</div>
										</div>
									</div>

									<div className="print-sub-tests">
										{testResult.subtests.map((subtest) => {
											return (
												<Subtest
													subtest={subtest}
													type={this.state.testType}
													testType={
														this.state.testType
													} //is going to be used for better rendering of gjennomsnitting og stadaravvik skåre
													testResult={
														this.state.testResult
													}
													key={subtest.id}
													isSuperAdmin={
														this.props.currentUser
															.isSuperAdmin
													}
													testId={
														this.props.match.params
															.id
													}
													resetSubtest={(
														testId,
														subtestId
													) => {
														this.safelyDeleteSubtest(
															testId,
															subtestId
														);
													}}
												>
													<SubtestAnswers
														subtest={subtest}
														testType={
															this.state.testType
														}
														grade={
															this.state.testUser
																.education
																.youthGrade
														}
														viewModes={
															this.state.viewModes
														}
													/>
												</Subtest>
											);
										})}
										{/* {[
											'youth-screening',
											'adult-screening',
											'child-screening',
										].includes(this.state.testType) && (
											<div
												style={{
													marginTop: '20px',
													fontSize: '16px',
												}}
											>
												<strong>Z-scores:</strong>

												{testResult.subtests.map(
													(subtest) => {
														const names = {
															1: 'Orddiktat',
															2: 'Ordkjedetesten',
															3: 'Byttelydtesten',
															4: 'Skrivehastighet',
															5: 'Leseprøven',
															6: 'Ordforståelse',
															7: 'Setningsforståelse',
														};

														return (
															<div
																key={subtest.id}
															>
																{
																	names[
																		subtest
																			.id
																	]
																}
																:{' '}
																<b>
																	{
																		subtest.zScore
																	}
																</b>
															</div>
														);
													}
												)}
											</div>
										)} */}
										{[
											'youth-screening',
											'adult-screening',
											'child-screening',
										].includes(this.state.testType) && (
											<div className="lit-report-assessment">
												<Assessment
													grade={Number(
														this.state.testUser
															.education
															.youthGrade
													)}
													testResult={testResult}
													completeName={completeName}
													firstName={firstName}
													testReportLang={
														this.state
															.testReportLang
													}
													useDysmate2Handbook
												/>
											</div>
										)}
									</div>
								</div>
							</div>
						)}
					{showTestUserInfo && (
						<TestUserInfo
							testResult={testResult}
							testType={this.state.testType}
							testReportLang={this.state.testReportLang}
						/>
					)}
					{this.state.showReportTab &&
						!this.state.showTestUserInfo && (
							<div className="lit-histogram-Test_Report">
								<div className="lit-printBtn">
									<button
										className={classNames('print-hide', {
											'lit-btn2 see-more': true,
											'bg-tertiary': true,
										})}
										onClick={() => {
											this.updatePrintLog('Report');
											this.setState({reportNotes: ''});
											this.toggleAddNotesModal();
										}}
									>
										<FontAwesomeIcon
											size="lg"
											className="lit-icon-btns"
											icon={faPrint}
										/>

										<p className="lit-btns-txt">
											{strings.formatString(
												strings.printwithcomment,
												strings.testreport
											)}
										</p>
									</button>
									<button
										className="lit-mytests-header-mytest-btn-primary"
										onClick={() => {
											this.onClickTranslateReport();
										}}
									>
										<FontAwesomeIcon
											size="lg"
											className="lit-icon-btns"
											icon={faLanguage}
										/>

										<p className="lit-btns-txt">
											{testReportLang === 'nn'
												? strings._props.nn
														.translateToNorsk
												: strings.translateToNynorsk}
										</p>
									</button>
									{this.state.showAlert && (
										<AlertBox
											type={
												this.state.success
													? 'success'
													: 'error'
											}
											message={this.state.message}
										/>
									)}
								</div>
								<div className="lit-results-background">
									<div className="sub-test total print-summary">
										{!testResult.completedAt && (
											<div className="incomplete-notice">
												{strings.incompleteMessage}
											</div>
										)}

										<ReportIntroduction
											testType={this.state.testType}
											testResult={testResult}
											testReportLang={
												this.state.testReportLang
											}
											useDysmate2Handbook
										/>

						<div className="summary-section">
						<h3 className="sub-test__name big">
											{strings.formatString(
												strings.summary,
												strings.testreport
											)}
										</h3>
						<div className="summary-chart">
											<HorizontalBarChart
												subtests={testResult.subtests}
												testType={this.state.testType}
											/>
						</div>
						</div>
						<div className="explanations">
											<div className="explanation">
												<div className="explanation__figure negative" />
												<p className="explanation__text">
													{strings.formatString(
														zscorered,
														<em>{strings.under}</em>
													)}
												</p>
											</div>
											<div className="explanation">
												<div className="explanation__figure neutral" />
												<p className="explanation__text">
													{zscoreblue}
												</p>
											</div>
											<div className="explanation">
												<div className="explanation__figure positive" />
												<p className="explanation__text">
													{strings.formatString(
														zscoregreen,
														<em>{strings.over}</em>
													)}
												</p>
											</div>
										</div>

										<div className="print-sub-tests">
											{testResult.subtests.map(
												(subtest) => {
													return (
														<SubtestReport
															subtest={subtest}
															key={subtest.id}
															type={
																this.state
																	.testType
															}
															testResult={
																this.state
																	.testResult
															}
															testReportLang={
																this.state
																	.testReportLang
															}
														/>
													);
												}
											)}
										</div>
										{[
											'youth-screening',
											'adult-screening',
											'child-screening',
										].includes(this.state.testType) && (
												<Assessment
													grade={Number(
														this.state.testUser
															.education
															.youthGrade
													)}
													testResult={testResult}
													completeName={completeName}
													firstName={firstName}
													testReportLang={
														this.state
															.testReportLang
													}
													useDysmate2Handbook
												/>
										)}

										{reportNotes && (
											<>
												<div className="sub-test__comment-page-breaker" />
												<div className="sub-test__comment">
													<h4 className="sub-test__heading big">
														<span className="comment">
															{
																strings.commentsLabel
															}
														</span>
														<p className="report-notes">
															{reportNotes}
														</p>
														<div className="line-one-text">
															{
																strings.commentWrittenByAdministrator
															}{' '}
															{ownerFullName}
														</div>
														<div className="line-container">
															<div className="line line-1" />
														</div>
													</h4>
												</div>
											</>
										)}
									</div>
								</div>
							</div>
						)}
					{this.state.showHandBookTab && (
						<HandBook useDysmate2Handbook />
					)}
					{this.state.showAddNotesModal && (
						<AddNotesModal
							showModal={this.state.showAddNotesModal}
							toggleModal={this.toggleAddNotesModal}
							reportNotes={reportNotes}
							setReportNotes={(notes) => {
								this.setState({reportNotes: notes});
							}}
						/>
					)}
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	const {currentUser} = state;

	return {
		currentUser,
	};
};

const mapDispatchToProps = {};

export default withRouter(
	connect(mapStateToProps, mapDispatchToProps)(SingleTest)
);
